// extracted by mini-css-extract-plugin
export var content = "hero-module--content--d66e0";
export var first = "hero-module--first--490fb";
export var hcaption = "hero-module--hcaption--f5551";
export var hero = "hero-module--hero--86fc3";
export var hjourn = "hero-module--hjourn--ec55e";
export var notmain = "hero-module--notmain--25988";
export var over_cont = "hero-module--over_cont--4a977";
export var overlay = "hero-module--overlay--36c9a";
export var video = "hero-module--video--23112";
export var wide = "hero-module--wide--d88c0";